import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Col, Row } from 'react-bootstrap';
import LoadingComponent from '../components/LoadingComponent';
import Request from '../utils/Request';

type Props = {
  loading?: React.RefObject<LoadingComponent | null>;
};

type State = {
  text: undefined;
  photo?: string;
};

export default class JoinUsPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { text: undefined, photo: undefined };
  }

  componentDidMount() {
    document.title = (process.env.REACT_APP_NAME ?? 'Kaz Studio') + ' - About us';

    Request.sendRequest('about-list/join-us-page').then((result) => {
      const text = result.data.data.content;
      this.setState({ text: text });
      this.props.loading?.current?.closeAnimation();
    });

    Request.sendRequest('about-list/join-us-page/photo').then((result) => {
      this.setState({ photo: result.data.data.url });
    });
  }

  render() {
    return (
      <>
        <div className="page about-page">
          <Row className="content">
            <Col className="col-sm-auto">
              {this.state.photo ? (
                <img src={this.state.photo} className="photo" />
              ) : (
                <Skeleton baseColor="#707070" highlightColor="#535353" height={250} width={250} />
              )}
            </Col>
            <Col md={6}>
              <div className="fade-in-image">
                {this.state.text ? (
                  <div className="text" dangerouslySetInnerHTML={{ __html: this.state.text }}></div>
                ) : (
                  <>
                    <Skeleton
                      className="mb-2"
                      baseColor="#707070"
                      highlightColor="#535353"
                      count={1}
                      width={250}
                      height={20}
                    />
                    <Skeleton baseColor="#707070" highlightColor="#535353" count={2} height={10} />
                    <Skeleton
                      baseColor="#707070"
                      highlightColor="#535353"
                      count={1}
                      width="60%"
                      height={10}
                    />
                    <Skeleton
                      baseColor="#707070"
                      highlightColor="#535353"
                      count={1}
                      width="80%"
                      height={10}
                    />
                  </>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}
